import _objectSpread from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";

var _hoisted_1 = /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "高级设置", -1);

var _hoisted_2 = {
  class: "advanced-setting-modal-content"
};
var _hoisted_3 = {
  class: "concent-top"
};
var _hoisted_4 = {
  class: "title"
};
var _hoisted_5 = {
  class: "concent-bottom"
};
var _hoisted_6 = {
  class: "description"
};
var _hoisted_7 = ["onClick"];

var _hoisted_8 = /*#__PURE__*/_createTextVNode("。 ");

var _hoisted_9 = {
  class: "advanced-setting-modal-footer"
};

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 取消 ");

var _hoisted_11 = /*#__PURE__*/_createTextVNode(" 确定 ");

import { ref, toRefs } from 'vue';
import { useRoute } from 'vue-router';
import CompanyService from '@/api/company';
import { pick } from 'lodash';
import { ElMessage } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  props: {
    settingList: null
  },
  setup: function setup(__props, _ref) {
    var expose = _ref.expose;
    var props = __props;
    var route = useRoute();

    var _toRefs = toRefs(props),
        settingList = _toRefs.settingList; // 弹窗是否显示


    var dialogVisible = ref(false);

    var open = function open() {
      dialogVisible.value = true;
    };
    /**
     * 点击链接跳转
     */


    var onClickLinkBtn = function onClickLinkBtn(url) {
      window.open(url);
    };
    /**
     * 点击关闭设置
     */


    var onCloseDialog = function onCloseDialog() {
      dialogVisible.value = false;
    };
    /**
     * 提交设置
     */


    var onConfirm = function onConfirm() {
      CompanyService.setBizFunction({
        appGroup: 'beacon',
        bizId: route.params.biz_url,
        appKeyFunctionList: settingList.value.map(function (setting) {
          return _objectSpread({}, pick(setting, ['activated', 'appKey', 'functionId']));
        })
      }).then(function (res) {
        var _res$data;

        if (((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 1) {
          ElMessage({
            message: '设置成功',
            type: 'success'
          }); // 关闭弹窗

          onCloseDialog();
        } else {
          var _res$data2;

          ElMessage({
            message: (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.msg,
            type: 'error'
          });
        }
      });
    };

    expose({
      open: open
    });
    return function (_ctx, _cache) {
      var _component_el_switch = _resolveComponent("el-switch");

      var _component_el_button = _resolveComponent("el-button");

      var _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return dialogVisible.value = $event;
        }),
        width: 560,
        "show-close": false,
        "destroy-on-close": "",
        "custom-class": "advanced-setting-modal"
      }, {
        title: _withCtx(function () {
          return [_createElementVNode("div", {
            class: "advanced-setting-modal-title"
          }, [_hoisted_1, _createElementVNode("i", {
            class: "iconfont iconclose-line",
            onClick: onCloseDialog
          })])];
        }),
        footer: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_9, [_createVNode(_component_el_button, {
            type: "info",
            onClick: onCloseDialog
          }, {
            default: _withCtx(function () {
              return [_hoisted_10];
            }),
            _: 1
          }), _createVNode(_component_el_button, {
            type: "primary",
            onClick: onConfirm
          }, {
            default: _withCtx(function () {
              return [_hoisted_11];
            }),
            _: 1
          })])];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(settingList), function (setting) {
            return _openBlock(), _createElementBlock("div", {
              key: setting.functionId,
              class: "setting-item"
            }, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(setting.functionName), 1), _createVNode(_component_el_switch, {
              modelValue: setting.activated,
              "onUpdate:modelValue": function onUpdateModelValue($event) {
                return setting.activated = $event;
              }
            }, null, 8, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createTextVNode(_toDisplayString(setting.description) + " ", 1), setting.clauseUrl ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              onClick: function onClick($event) {
                return onClickLinkBtn(setting.clauseUrl);
              }
            }, _toDisplayString(setting.clauseName), 9, _hoisted_7)) : _createCommentVNode("", true), _hoisted_8])])]);
          }), 128))])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});